import React from 'react';
import SkippedSuccess from 'components/Practice/Recording/SkippedSuccess';
import SkippedFailure from 'components/Practice/Recording/SkippedFailure';
import ReportTechnicalDifficultiesMessage from 'components/Practice/Recording/ReportTechnicalDifficultiesMessage';

const SkippedMessage = ({
  mediaButtonClass,
  disabledMediaButtonClass,
  uploadButtonText,
  recordButtonText,
  skipped,
  finished,
  disabled,
  reloadRecording,
  sendFeedbackError,
  technicalDifficultiesReported,
}) => {
  if (skipped) {
    return sendFeedbackError ? (
      <SkippedFailure
        mediaButtonClass={mediaButtonClass}
        disabledMediaButtonClass={disabledMediaButtonClass}
        recordButtonText={recordButtonText}
        uploadButtonText={uploadButtonText}
        finished={finished}
        disabled={disabled}
        showTechnicalDifficulties
        reloadRecording={reloadRecording}
      />
    ) : (
      <SkippedSuccess
        mediaButtonClass={mediaButtonClass}
        disabledMediaButtonClass={disabledMediaButtonClass}
        recordButtonText={recordButtonText}
        uploadButtonText={uploadButtonText}
        finished={finished}
        disabled={disabled}
        showTechnicalDifficulties
        reloadRecording={reloadRecording}
      />
    );
  }
  return (
    (technicalDifficultiesReported || sendFeedbackError) && (
      <ReportTechnicalDifficultiesMessage
        reloadRecording={reloadRecording}
        sendFeedbackError={sendFeedbackError}
      />
    )
  );
};

export default SkippedMessage;
